module.exports = __webpack_public_path__ + "img/10.5fc6b566.png";